<template>
	<nav>
		<v-app-bar dark flat app clipped-left clipped-right color="primary">
			<v-app-bar-nav-icon @click="drawer = !drawer" class="hidden-lg-and-up" :class="$emerald.ifLang('ar', '', 'ms-1')"></v-app-bar-nav-icon>

			<v-toolbar-title>
				<router-link :to="{name: 'home'}">
					<v-img
						v-if="current_financial_file.company_logo_file"
						left
						contain
						:src="file_logo"
						max-width="80"
						max-height="55"
						class="shrink me-2"
						alt="N/A Logo"
						transtion="scale-transition"
					></v-img>

					<v-img
						v-else
						:src="require('../assets/EMERALD Icon.png')"
						contain
						left
						max-width="50"
						max-height="45"
						class="shrink me-2"
						transtion="scale-transition"
						alt="N/A Logo"
					></v-img>
				</router-link>
			</v-toolbar-title>
            
            <!-- menus -->
			<v-toolbar-items class="hidden-md-and-down">
				<template v-if="showMenus">
					<!-- accounting-->
					<v-menu offset-y transition="slide-y-transition">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								dark
								color="transparent"
								:depressed="true"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small class="me-1">fa fa-briefcase</v-icon>
								{{$t('accounting.name')}}
							</v-btn>
						</template>

						<bee-list :items="groups.find(c => c.name == $t('accounting.name')).items"></bee-list>
					</v-menu>

					<!-- materials & warehouses-->
					<v-menu offset-y transition="slide-y-transition">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:depressed="true"
								color="transparent"
								dark
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small class="me-1">fa-warehouse</v-icon>
								{{$t('materials-warehouses.name')}}
							</v-btn>
						</template>

						<bee-list :items="groups.find(c => c.name == $t('materials-warehouses.name')).items"></bee-list>
					</v-menu>
				</template>

                <!-- statistics-->
				<v-menu v-if="isAdmin && !currentFinancialFileId" offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							:depressed="true"
							color="transparent"
							dark
							v-bind="attrs"
							v-on="on"
							@click="
								!$route.name.includes('statistics')
								? $router.push({ name: 'statistics-final-accounts' })
								: null"
						>
							<v-icon small class="me-1">fa-chart-bar</v-icon>
							{{$t('statistics.name')}}	
						</v-btn>
					</template>
					<!-- <bee-list :items="groups.find(c => c.name == $t('statistics.name')).items"></bee-list> -->
				</v-menu>

				<!-- settings-->
				<v-menu v-if="showMenus" offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="transparent"
							:depressed="true"
							dark
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small class="me-1">mdi-cog-outline</v-icon>
							{{$t('settings.name')}}
						</v-btn>
					</template>
					<bee-list :items="groups.find(c=>c.name == $t('settings.name')).items"></bee-list>
				</v-menu>
				
				<!-- system management-->
				<v-menu offset-y transition="slide-y-transition">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-if="isAdmin"
							color="transparent"
							:depressed="true"
							dark
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small class="me-1">fa-user-shield</v-icon>
							{{$t('system-management.name')}}
						</v-btn>
					</template>
					<bee-list :items="groups.find(c => c.name == $t('system-management.name')).items"></bee-list>
				</v-menu>
			</v-toolbar-items>

			<v-spacer></v-spacer>

			<v-icon type="button" size="21" class="mx-2">fa-bell</v-icon>

            <!-- users menu -->
			<v-menu bottom offset-y right transition="slide-y-transition">
				<template v-slot:activator="{ on }">
					<v-chip outlined v-on="on" class="rounded-xl">
						<v-avatar left>
							<v-icon type="button" v-on="on" class="mx-2" size="21">fa-user-circle</v-icon>
						</v-avatar>
						<span style="font-weight: 300 !important;">{{current_user_name}}</span>
					</v-chip>
				</template>
				<bee-list>
					<bee-list-item
						:context="accountSettings[1].context"
						:item="accountSettings[1]"
						@click="dialog = true"
					></bee-list-item>
					<bee-list-item
						:context="accountSettings[0].context"
						:item="accountSettings[0]"
						@click="logout()"
					></bee-list-item>
				</bee-list>
			</v-menu>

			<!-- language menu -->
			<v-menu bottom offset-y right transition="slide-y-transition">
				<template v-slot:activator="{ on }">
					<v-chip outlined v-on="on" class="rounded-xl ms-2">
						{{$i18n.locale.toLocaleUpperCase()}}
						<!-- <v-icon size="23">mdi-web</v-icon> -->
					</v-chip>
				</template>
				<bee-list>
					<bee-list-item
						v-for="(lang, index) in langs"
						:key="lang"
						:item="langListItems[index]"
						class="text-center"
						:class="{'v-list-item--active': $i18n.locale === lang}"
						dense
						@click="i18nSetLang(lang)"
						:context="langListItems[index].context"
					></bee-list-item>
				</bee-list>
			</v-menu>

			<v-divider vertical inset class="mx-2"></v-divider>

			<!-- current financial file -->
			<v-card-subtitle
				v-if="currentFinancialFileId"
				@click="dialogFileInfo = true"
				class="white--text text-center hover rounded"
				style="font-weight: 500 !important; cursor: pointer; border: 0px solid #ffffff1f; padding-block: inherit; margin-left: 9px !important;margin-right: 3px;"
			>
				{{file_name}}
				<br />
				{{file_year}}
			</v-card-subtitle>

			<v-btn
				v-else
				:to="{ name: 'quick-financial-file-selector'}"
				text
			>
				{{$t('select-financial-file')}}
			</v-btn>
		</v-app-bar>

        <!-- drawer -->
		<v-navigation-drawer  :right="$emerald.ifLang('ar', true, false)" app v-model="drawer" v-show="on_mdAndUp" temporary>
			<bee-list-item
				context="financial_file"
				@click="drawer = !drawer"
				:item="{icon: 'mdi-menu', text: showMenus ? `${file_name} - ${file_year}` : null, with_divider: false, action_name: actions.GET}"
			></bee-list-item>

			<v-divider class="mx-2"></v-divider>
			
			<bee-list-item
				v-if="!showMenus"
				context="financial_file"
				@click="
					!$route.name.includes('statistics')
						? $router.push({ name: 'statistics-final-accounts' })
						: null"
				:item="{icon: 'fa-chart-bar', text: $t('statistics.name'), with_divider: false, action_name: actions.GET}"
			></bee-list-item>
			
			<!-- <bee-list
				v-if="
					!$route.name.includes('statistics') &&
					$route.name !== 'quick-financial-file-selector'
				"
				@select="drawer = false"
				:groups="isAdmin ? groups : groups.filter(c=>c.name != this.$t('system-management.name'))"
				@click="close()"
			></bee-list> -->
			
			<!-- menus -->
			<v-list nav>
				<template
					v-if="
 						!$route.name.includes('statistics') &&
 						$route.name !== 'quick-financial-file-selector'
 					"
				>
					<v-list-group
						v-for="(group, index) in groups.filter(c => c.name !== $t('system-management.name'))"
						:key="index"
					>
						<template v-slot:activator>
							<v-list-item-icon><v-icon>{{group.icon}}</v-icon></v-list-item-icon>
							<v-list-item-title>{{group.name}}</v-list-item-title>
						</template>
						<template v-for="(item, i) in group.items">
							<v-list-item
								:key="'item-' + i"
								:to="item.route"
								@click="drawer = false"
							>
								<v-list-item-icon v-if="item.icon">
									<v-icon>{{item.icon}}</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>{{item.text}}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-divider v-if="item.with_divider" :key="'divider-' + i"/>
						</template>
					</v-list-group>
				</template>

				<!-- system management -->
				<v-list-group v-if="isAdmin">
					<template v-slot:activator>
						<v-list-item-icon><v-icon>fa-user-shield</v-icon></v-list-item-icon>
						<v-list-item-title>{{$t('system-management.name')}}</v-list-item-title>
					</template>
					<template v-for="(item, i) in groups.find(c => c.name === $t('system-management.name')).items">
						<v-list-item
							:key="'item-' + i"
							:to="item.route"
							@click="drawer = false"
						>
							<v-list-item-icon v-if="item.icon">
								<v-icon>{{item.icon}}</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{item.text}}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-divider v-if="item.with_divider" :key="'divider-' + i"/>
					</template>
				</v-list-group>
			</v-list>
		</v-navigation-drawer>

        <!-- logout dialog -->
		<bee-dialog
			:confirm-btn-content="$t('change')"
			@handler="$router.replace({ name: 'quick-financial-file-selector', query: { isChange: true } })"
			@close="dialogFileInfo = false"
			v-model="dialogFileInfo"
			:title="$t('file-name-$-fiscal-year-$', {fileName: file_name, fileYear: file_year})"
			:message="message"
		></bee-dialog>

        <!-- confirm changing password dialog -->
		<bee-confirm-dialog
			@close="logout(); reLoginDialog = false"
			v-model="reLoginDialog"
			:title="$t('change-password')"
			:message="$t('success-change-message')"
		></bee-confirm-dialog>

        <!-- change password dialog -->
		<v-form v-model="valid" ref="form">
			<v-dialog persistent v-model="dialog" max-width="400px" transition="dialog-top-transition">
				<v-card>
					<v-card-title>{{$t('change-password')}}</v-card-title>
					<v-card-text>
						<v-row class="my-0">
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.EDIT"
									:disabled="true"
									v-model="current_user.user_name"
									:label="$t('username')"
								></bee-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.GET"
									v-model="old_password"
									:label="$t('old-password')"
									:rules="[rules.required]"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPass ? 'text' : 'password'"
									@click-append="showPass = !showPass"
								></bee-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.GET"
									v-model="new_password"
									:label="$t('new-password')"
									:rules="[rules.required, rules.password]"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPass ? 'text' : 'password'"
									@click-append="showPass = !showPass"
								></bee-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12" class="pb-0">
								<bee-text-field
									context="user"
									:action-name="actions.GET"
									v-model="new_password_repeated"
									:label="$t('rewrite-new-password')"
									:rules="[rules.required, rules.password]"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPass ? 'text' : 'password'"
									@click-append="showPass = !showPass"
								></bee-text-field>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-btn color="greenDarken1" text @click="changePassword()" :disabled="!valid">
							{{$t('save')}}
						</v-btn>
						<v-btn color="redDarken1" text @click="reset()">
							{{$t('cancel')}}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-form>
	</nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import * as settings from "../settings/index.js";
import { i18nSetLang } from '../i18n/i18n.js'
import actions from "../permissions/actions-names.js";
import ls from "../settings/localStorageExtension";
import store from "../store/index.js";
import rules from "../validation";
import { multipleWarehouses, useInvoicesTypes, useSalesStatement } from '@/configs/global'

export default {
	name: "Navigation",

	data() {
		return {
			new_password_repeated: null,
			old_password: null,
			...rules,
			reLoginDialog: false,
			dialog: false,
			showPass: false,
			valid: false,
			actions,
			dialogFileInfo: false,
			drawer: false,
			showAccounts: false,
			new_password: null,

			// languages
			langs: [],
			langListItems: [],

			currentFinancialFileId: ls.getLocalFinancialFileId(),
		};
	},

	watch: {
		'$route.name'(val) {
			if (val === 'quick-financial-file-selector') {
				this.currentFinancialFileId = ls.getLocalFinancialFileId();
			}
		}
	},

	computed: {
		accountSettings(){
			return [
				{
					text: this.$t('logout'),
					icon: "",
					context: "user",
					action_name: actions.GET
				},
				{
					text: this.$t('change-password'),
					icon: "",
					context: "user",
					action_name: actions.GET
				}
			]
		},

		...mapState("configs", ["configs"]),
		...mapState("configs", ["system_paths"]),
		...mapState("financialFiles", ["current_financial_file"]),
		...mapGetters({ isAdmin: "auth/isAdmin" }),
		...mapGetters({ current_user_name: "auth/username" }),

		current_user() {
			return ls.getLocalUser();
		},
		on_mdAndUp() {
			if (this.$vuetify.breakpoint.mdAndUp) this.close();
			return true;
		},
		file_name() {
			return this.configs?.financial_file?.company_name;
		},
		file_year() {
			return this.configs?.financial_file?.year_name;
		},
		file_logo() {
			return (
				this.current_financial_file.company_logo_file
					? (
						axios.defaults.baseURL.replace("/api/", "") +
						"/Content/FinancialFiles/Logos/" +
						this.current_financial_file.company_logo_file
					)
					: null
			);
		},

		message() {
			return this.$t('do-you-want-to-change-the-financial-file');
		},

		groups() {
			const groups = [
				{
					name: this.$t('accounting.name'),
					icon: "fa fa-briefcase",
					items: [
						{
							text: this.$t('accounting.items.accounts-tree'),
							icon: "",
							route: { name: "accounts-tree" },
							with_divider: true,
							context: "account",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.accounting-journal'),
							icon: "",
							route: { name: "accounting-journal" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.cash-journal'),
							icon: "",
							route: { name: "cash-journals" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.journal-table'),
							icon: "",
							route: { name: "journal-table" },
							with_divider: true,
							context: "daily_table",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.account-statement'),
							icon: "",
							route: { name: "account-statement" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.advance-statement'),
							icon: "",
							route: { name: "advance-statement" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.account-custom-statement'),
							icon: "",
							route: { name: "account-custom-statement" },
							with_divider: true,
							context: "custom_statement",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.trial-balance'),
							icon: "",
							route: { name: "trail-balance" },
							with_divider: false,
							context: "trial_balance",
							action_name: actions.GET
						},
						{
							text: this.$t('accounting.items.final-accounts'),
							icon: "",
							route: { name: "final-accounts" },
							with_divider: false,
							context: "final_account",
							action_name: actions.GET
						}
					]
				},
				{
					name: this.$t('materials-warehouses.name'),
					icon: "fa-warehouse",
					items: [
						{
							text: this.$t('materials-warehouses.items.invoices-sale'),
							icon: "",
							route: { name: "invoices-sale" },
							with_divider: false,
							context: "invoice",
							action_name: actions.GET,
						},
						{
							text: this.$t('materials-warehouses.items.invoices-buy'),
							icon: "",
							route: { name: "invoices-buy" },
							with_divider: false,
							context: "invoice",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.sale-invoice-refund'),
							icon: "",
							route: { name: "sale-invoice-refund" },
							with_divider: false,
							context: "invoice",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.buy-invoice-refund'),
							icon: "",
							route: { name: "buy-invoice-refund" },
							with_divider: true,
							context: "invoice",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.materials-tree'),
							icon: "",
							route: {
								name: "materials-tree",
								params: { warehouseId: Number(this.configs?.warehouse?.id) }
							},
							with_divider: false,
							context: "warehouse",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.materials-journal'),
							icon: "",
							route: { name: "materials-journals" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.transfer-document'),
							icon: "",
							route: { name: "transfer-document" },
							with_divider: false,
							context: "bond",
							action_name: actions.GET,
							hide: !multipleWarehouses
						},
						{
							text: this.$t('materials-warehouses.items.manufacturing-bond'),
							icon: "",
							route: { name: "manufacturing-bond" },
							with_divider: true,
							context: "bond",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.material-statement'),
							icon: "",
							route: { name: "materials-statment" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET
						},
						{
							text: this.$t('materials-warehouses.items.warehouse-inventory'),
							icon: "",
							route: { name: "warehouses-inventory" },
							with_divider: false,
							context: "statement",
							action_name: actions.GET
						}
					].filter(c => !c.hide)
				},
				// {
				// 	name: this.$t('statistics.name'),
				// 	icon: "fa-chart-bar",
				// 	items: []
				// },
				{
					name: this.$t('settings.name'),
					icon: "mdi-cog-outline",
					items: [
						{
							text: this.$t('settings.items.general-settings'),
							icon: "",
							route: { name: "settings" },
							with_divider: true,
							context: "user_preferences",
							action_name: actions.GET
						},
						{
							text: this.$t('settings.items.financial-file-accounts'),
							icon: "",
							route: { name: "default-accounts" },
							with_divider: false,
							context: "account",
							action_name: actions.GET
						},
						{
							text: this.$t('settings.items.custom-statements'),
							icon: "",
							route: { name: "custom-statements" },
							with_divider: true,
							context: "custom_statement",
							action_name: actions.GET
						},
						{
							text: this.$t('settings.items.warehouses'),
							icon: "",
							route: { name: "warehouses" },
							with_divider: false,
							context: "warehouse",
							action_name: actions.GET
						},
						{
							text: this.$t('settings.items.measuring-units'),
							icon: "",
							route: { name: "unit-sizes" },
							with_divider: true,
							context: "unit_size",
							action_name: actions.GET
						},
						{
							text: this.$t('system-management.items.audit-log'),
							icon: "",
							route: { name: "audit-log" },
							context: "financial_file",
							action_name: actions.GET,
							hide: !this.currentFinancialFileId
						},
						{
							text: "UI " + settings.UI_VERSION,
							icon: "",
							with_divider: false,
							context: "daily_table", /////////// WILL REMOVE /////
							action_name: actions.GET
						}
					].filter(c => !c.hide)
				},
				{
					name: this.$t('system-management.name'),
					icon: "fa-user-shield",
					items: [
						{
							text: this.$t('system-management.items.users'),
							icon: "",
							route: { name: "users" },
							context: "user",
							action_name: actions.EDIT
						},
						{
							text: this.$t('system-management.items.financial-files'),
							icon: "",
							route: { name: "financial-files" },
							context: "financial_file",
							action_name: actions.EDIT
						},
						{
							text: this.$t('system-management.items.currencies'),
							icon: "",
							route: { name: "currencies" },
							context: "currency",
							action_name: actions.GET
						}
					]
				}
			];

			if (useInvoicesTypes) {
				groups.find(c => c.name === this.$t('settings.name'))?.items.splice(3, 0, {
					text: this.$t('settings.items.invoices-types'),
					route: { name: "invoices-types" },
					with_divider: false,
					context: "user_preferences",
					action_name: actions.GET
				});
			}
			if (useSalesStatement) {
				groups.find(c => c.name === this.$t('materials-warehouses.name'))?.items.splice(4, 0, {
					text: this.$t('materials-warehouses.items.sales-statement'),
					icon: "",
					route: { name: "sales-statement" },
					with_divider: true,
					context: "invoice",
					action_name: actions.GET
				});
			}

			return groups;
		},

		showMenus() {
			return (
				ls.getLocalFinancialFileId() &&
				!['login','quick-financial-file-selector'].includes(this.$route.name) &&
				!this.$route.name.includes('statistics')
			)
		}
	},

	methods: {
		close() {
			this.drawer = false;
        },
        
        // TODO remove forwardToHome, it's not used
		forwardToHome() {
			this.drawer = false;
			this.$router.push({
				name: "home"
			});
			close();
        },
        
		logout() {
			store.dispatch("auth/logout").then(() => {
				this.$router.replace({ name: "login" }).then(() => {
					this.$router.go(0); // Force refresh to empty the store
				});
			});
		},
		changePassword() {
			store.dispatch("users/changePassword", {
                old_password: this.old_password,
                new_password: this.new_password,
                new_password_repeated: this.new_password_repeated
            })
            .then(() => {
                this.reset();
                this.reLoginDialog = true;
            });
		},
		reset() {
			this.dialog = false;
			this.new_password = null;
			this.old_password = null;
			this.new_password_repeated = null;
			this.showPass = false;
			setTimeout(() => {
				this.$nextTick(() => {
					this.$refs.form.resetValidation();
				});
			}, 501);
		},

		// languages
		initLanguages(){
			this.langs = this.$i18n.availableLocales;
			this.langs.forEach(lang => {
				this.langListItems.push({
					text: lang.toLocaleUpperCase(),
					icon: "",
					disabled: false,
					context: "user",
					action_name: actions.GET
				})
			});
		},
		
		i18nSetLang,
	},

	mounted(){
		this.initLanguages();
	},

	i18n: {
		messages: {
			ar: {
				accounting: {
					name: 'المحاسبة',
					items: {
						'accounts-tree': 'شجرة الحسابات',
						'accounting-journal': 'اليومية المحاسبية',
						'cash-journal': 'اليومية النقدية',
						'journal-table': 'جدول اليومية',
						'account-statement': 'كشف حساب',
						'account-custom-statement': 'كشف حساب مخصص',
						'trial-balance': 'ميزان المراجعة',
						'final-accounts': 'الحسابات الختامية',
						'advance-statement': 'كشف أستاذ'
					}
				},

				'materials-warehouses': {
					name: 'المواد والمستودعات',
					items: {
						'invoices-sale': 'فاتورة بيع',
						'invoices-buy': 'فاتورة شراء',
						'sale-invoice-refund': 'فاتورة مرتجع بيع',
						'buy-invoice-refund': 'فاتوة مرتجع شراء',
						'sales-statement': 'كشف مبيعات',
						'materials-tree': 'شجرة المواد',
						'materials-journal': 'يومية المواد',
						'manufacturing-bond': 'سند التصنيع',
						'material-statement': 'كشف مادة',
						'warehouse-inventory': 'جرد المواد',
						'transfer-document': 'سند مناقلة'
					}
				},

				statistics: {
					name: 'الإحصائيات'
				},

				settings: {
					name: 'الإعدادات',
					items: {
						'general-settings': 'الإعدادات العامة',
						'financial-file-accounts': 'الحسابات الافتراضية',
						'custom-statements': 'الكشوف المخصصة',
						'warehouses': 'المستودعات',
						'measuring-units': 'واحدات القياس',
						'invoices-types': 'أنواع الفواتير',
					}
				},

				'system-management':{
					name: 'إدارة النظام',

					items: {
						users: 'المستخدمين',
						'financial-files': 'الملفات المالية',
						'currencies': 'العملات',
						'audit-log': 'سجلات المراقبة'
					}
				},

				change: 'تغيير',
				'change-password': 'تغيير كلمة المرور',
				'success-change-message': 'تم تحديث كلمة السر، يتوجب عليك إعادة تسجيل الدخول.',

				username: 'اسم المستخدم',
				'old-password': 'كلمة المرور القديمة',
				'new-password': 'كلمة المرور الجديدة',
				'rewrite-new-password': 'أعد كلمة المرور الجديدة',

				'file-name-$-fiscal-year-$': 'اسم الملف: {fileName} - السنة المالية: {fileYear}',
				'do-you-want-to-change-the-financial-file':'هل تريد تغيير الملف المالي؟',

				'save': 'حفظ',
				'cancel': 'إلغاء',
				logout: 'تسجيل الخروج',
				'select-financial-file': 'اختر ملف'
			},
			
			en: {
				accounting: {
					name: 'Accounting',
					items: {
						'accounts-tree': 'Accounts Tree',
						'accounting-journal': 'Accounting Journal',
						'cash-journal': 'Cash Journal',
						'journal-table': 'Journal',
						'account-statement': 'Account Statement',
						'account-custom-statement': 'Customised Account Statement',
						'trial-balance': 'Trial Balance',
						'final-accounts': 'Final Accounts',
						'advance-statement': 'Ledger Statement'
					}
				},

				'materials-warehouses': {
					name: 'Items & warehouses',
					
					items: {
						'invoices-sale': 'Sale Invoices',
						'invoices-buy': 'Purchase Invoices',
						'sale-invoice-refund': 'Sale invoice refund',
						'buy-invoice-refund': 'Purchase invoice refund',
						'sales-statement': 'Sales statement',
						'materials-tree': 'Items Tree',
						'materials-journal': 'Items Journal',
						'manufacturing-bond': 'Manufacturing Bond',
						'material-statement': 'Item Statement',
						'warehouse-inventory': 'Warehouse inventory',
						'transfer-document': 'Transfer document'
					}
				},

				statistics: {
					name: 'Statistics'
				},

				settings: {
					name: 'Settings',
					items: {
						'general-settings': 'General Settings',
						'financial-file-accounts': 'Default accounts',
						'custom-statements': 'Customised Statements',
						'warehouses': 'Warehouses',
						'measuring-units': 'Units',
						'invoices-types': 'Invoices types',
					}

				},

				'system-management':{
					name: 'System management',

					items: {
						users: 'Users',
						'financial-files': 'Financial Files',
						'currencies': 'Currencies',
						'audit-log': 'Audit Log'
					}
				},

				change: 'Change',
				'change-password': 'Change Password',
				'success-change-message': 'Your password has been updated, please sign in again.',

				username: 'Username',
				'old-password': 'Old password',
				'new-password': 'New password',
				'rewrite-new-password': 're-enter new password',

				'file-name-$-fiscal-year-$': 'File name: {fileName} - Fiscal year: {fileYear}',
				'do-you-want-to-change-the-financial-file': 'Do you want to change the financial file?',

				'save': 'Save',
				'cancel': 'Cancel',
				logout: 'Sign out',
				'select-financial-file': 'Select financial file'
			},
			
			es: {
				accounting: {
					name: 'Contabilidad',
					items: {
						'accounts-tree': 'Árbol de cuentas',
						'accounting-journal': 'Diario contable',
						'cash-journal': 'Diario de caja',
						'journal-table': 'Horario diario',
						'account-statement': 'Estado de cuenta',
						'account-custom-statement': 'Estado de cuenta personalizado',
						'trial-balance': 'Balance de prueba',
						'final-accounts': 'Cuentas finales',
						'advance-statement': 'Estado de cuenta'
					}
				},

				'materials-warehouses': {
					name: 'Artículos y almacenes',

				 	items: {
						'invoices-sale': 'Factura de venta',
						'invoices-buy': 'Factura de compra',
						'sale-invoice-refund': 'Factura de venta devuelta',
						'buy-invoice-refund': 'Factura de compra devuelta',
						'sales-statement': 'Declaración de venta',
						'materials-tree': 'Árbol de artículos',
						'materials-journal': 'Diario de artículos',
						'manufacturing-bond': 'Bono de fabricación',
						'material-statement': 'Estado de artículo',
						'warehouse-inventory': 'Inventario de Almacén',
						'transfer-document': 'Documento de transferencia'
					}			
				},

				statistics: {
					name: 'Estadísticas'
				},

				settings: {
					name: 'Ajustes',
					items: {
						'general-settings': 'Ajustes generales',
						'financial-file-accounts': 'Cuentas predeterminadas',
						'custom-statements': 'Estados personalizados',
						'warehouses': 'Almacenes',
						'measuring-units': 'Unidades',
						'invoices-types': 'Tipos de facturas',
					}
				},

				'system-management':{
					name: 'Gestión de sistema',

					items: {
						users: 'Usuarios',
						'financial-files': 'Archivos financieros',
						'currencies': 'monedas',
						'audit-log' : 'registro de auditoría'
					}
				},
				
				change: 'Cambiar',
				'change-password': 'Cambiar contraseña',
				'success-change-message': 'Su contraseña ha sido actualizada, debe volver a iniciar sesión.',

				username: 'Usuario',
				'old-password': 'Contraseña antigua',
				'new-password': 'Contraseña nueva',
				'rewrite-new-password': 'Repetir la nueva contraseña',
				'file-name-$-fiscal-year-$': 'Nombre de archivo: {fileName} - Año fisical: {fileYear}',
				'do-you-want-to-change-the-financial-file':'¿Quieres cambiar el archivo financiero?',
				
				'save': 'Guardar',
				'cancel': 'Cancelar',
				logout: 'Cerrar sessión',
				'select-financial-file': 'Seleccionar archivo financiero'
			}
		}
	}
};
</script>
<style scoped>
.hover:hover {
	background-color: rgba(255, 255, 255, 0.2) !important;
}
</style>
